import React from 'react'
import { FaUserCheck } from "react-icons/fa";
import { IoSettingsOutline } from "react-icons/io5";
import { CiGlobe } from "react-icons/ci";
import { GoSignOut } from "react-icons/go";
import { Link } from 'react-router-dom';
import AdminBanner from './AdminBanner';

function Account() {

    // Handler for sign out: remove token and reload page
    const handleSignOut = () => {
        localStorage.removeItem('token');
        window.location.reload();
    };

    return (
        <>
        <div className='absolute right-3 top-[00px] z-50 w-[140px] py-8'>
         
        <div className='w-[100%] bg-[#fff] dark:bg-[#121519]  p-3 rounded-md'>
         <h1 className='text-[#858c97] text-[10px] dark:text-[#fff] '>ACCOUNT</h1>

         <div className='pl-3 py-2'>
         <Link to='/Client/MyProfile'>
                            <div className='hover:text-[#ed7b00] flex items-center text-[10px] text-[#434a57] font-semibold gap-2 cursor-pointer dark:text-[#fff]'>
                                <FaUserCheck className='text-[14px]' />
                                <span>My Profile</span>
                            </div>
                        </Link>

                        <Link to='/Client/MyPassword'>
                            <div className='hover:text-[#ed7b00] flex items-center text-[10px] text-[#434a57] font-semibold gap-2 cursor-pointer mt-3 dark:text-[#fff]'>
                                <IoSettingsOutline className='text-[14px]' />
                                <span>Change Password</span>
                            </div>
                        </Link>

                       

                        <Link to='/Comingsoon'>
                        <div className='hover:text-[#ed7b00] flex items-center text-[10px] text-[#434a57] font-semibold gap-2 cursor-pointer mt-3 dark:text-[#fff]'>
                            <CiGlobe className='text-[14px]' />
                            <span>System Support</span>
                        </div>
                        </Link>
            <div className='mt-3 bg-[#d8d8db] h-[1px] w-[100%]'></div>
            <AdminBanner />
            <div
                className=' hover:text-[#ed7b00] flex items-center text-[10px] text-[#434a57] font-semibold gap-2 cursor-pointer mt-3 dark:text-[#fff]'
                onClick={handleSignOut}
            >
                <GoSignOut className='text-[14px]' />
                <span>Sign Out</span>
            </div>
         </div>
        </div>
         </div>
        </>
    )
}

export default Account
